
import {map} from 'rxjs/operators';
import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserProfileRecord } from './user-profile-record';

import { AlertMessagesConfig } from 'config/alert-messages.config';

@Injectable()
export class UserService  { 
  private _profile!: UserProfileRecord;

  constructor(
    private http: HttpClient,
    private alertMessages: AlertMessagesConfig
  ) {}


  setProfile(profile: UserProfileRecord) {
    this._profile = profile;
    return this;
  }

  get profile(): UserProfileRecord {
    return this._profile;
  }

  isInGroup(group: string): boolean {
    if (!this._profile) {
      return false;
    }

    if (this._profile.groups.toLocaleLowerCase().match(group.toLocaleLowerCase())) {
      return true;
    } else {
      return false;
    }
  }


}
